import { createEntityAdapter } from '@reduxjs/toolkit'
import { ICategory } from '../../types'

export const categoriesAdapter = createEntityAdapter<ICategory>()